import { Card } from "./Card";
import { Pile } from "./Pile";

export class GameRules {
  canMoveToFoundation(cards: Card[], targetPile: Pile): boolean {
    if (cards.length !== 1) return false;
    
    // Cannot move to completed foundation pile (13 cards)
    if (targetPile.cards.length >= 13) return false;
    
    const card = cards[0];
    
    if (targetPile.isEmpty()) {
      return card.rank === "A";
    }
    
    const topCard = targetPile.getTopCard()!;
    return (
      card.suit === topCard.suit &&
      card.getNumericValue() === topCard.getNumericValue() + 1
    );
  }

  isFoundationComplete(pile: Pile): boolean {
    return pile.type === "foundation" && pile.cards.length === 13;
  }

  canMoveToTableau(cards: Card[], targetPile: Pile): boolean {
    if (cards.length === 0) return false;
    
    const firstCard = cards[0];
    
    if (targetPile.isEmpty()) {
      // Allow any card to be placed on empty tableau
      return true;
    }
    
    const topCard = targetPile.getTopCard()!;
    if (!topCard.faceUp) return false;
    
    // Allow same-color stacking - only check descending order
    return firstCard.getNumericValue() === topCard.getNumericValue() - 1;
  }

  canMove(cards: Card[], sourcePile: Pile, targetPile: Pile): boolean {
    if (sourcePile === targetPile) return false;
    if (targetPile.type === "stock" || targetPile.type === "waste") return false;
    
    if (!this.isValidSequence(cards)) return false;
    
    switch (targetPile.type) {
      case "foundation":
        return this.canMoveToFoundation(cards, targetPile);
      case "tableau":
        return this.canMoveToTableau(cards, targetPile);
      default:
        return false;
    }
  }

  isValidSequence(cards: Card[]): boolean {
    if (cards.length <= 1) return true;
    
    for (let i = 0; i < cards.length - 1; i++) {
      const current = cards[i];
      const next = cards[i + 1];
      
      // Allow same-color stacking - only check descending order
      if (current.getNumericValue() !== next.getNumericValue() + 1) {
        return false;
      }
    }
    return true;
  }

  isGameWon(foundationPiles: Pile[]): boolean {
    return foundationPiles.every(pile => pile.cards.length === 13);
  }

  hasCompletedSequence(pile: Pile): boolean {
    if (pile.type !== "tableau") return false;
    if (pile.cards.length !== 13) return false;
    
    // Check if all cards are face-up
    if (!pile.cards.every(card => card.faceUp)) return false;
    
    // Check if it's a complete sequence (K down to A) of the same suit
    const firstCard = pile.cards[0];
    const suit = firstCard.suit;
    
    // Verify all cards are same suit
    if (!pile.cards.every(card => card.suit === suit)) return false;
    
    // Verify sequence: K (13), Q (12), J (11), ..., 2 (2), A (1)
    for (let i = 0; i < pile.cards.length; i++) {
      const expectedValue = 13 - i;
      if (pile.cards[i].getNumericValue() !== expectedValue) {
        return false;
      }
    }
    
    return true;
  }
}

